export const ARTICLE_TYPES = [
  { value: "TEMAS_CG", label: "Temas CG" },
  { value: "NOTICIAS_IT", label: "Noticias IT" },
];

export const STATUSES = [
  { value: "BORRADOR", label: "Borrador" },
  { value: "EN_REVISION", label: "En revisión" },
  { value: "APROBADO", label: "Aprobado" },
  { value: "PUBLICADO", label: "Publicado" },
];

export const STATUS_OPTIONS = [
  { value: true as any, label: "Activa" },
  { value: false as any, label: "Inactiva" },
];
